/**
 * Cloudflare Turnstile — configuração e classificação de erro.
 *
 * Quem VALIDA o token é a Supabase (a Secret Key mora em Authentication >
 * Attack Protection), não este código. Aqui só decidimos se o widget aparece
 * e como classificar o erro que a Supabase devolve.
 *
 * Env ausente = desligado: mantém dev local e a suíte Jest funcionando sem
 * conta Cloudflare.
 */

export function getTurnstileSiteKey(): string | null {
  const key = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY;
  if (!key || key.trim() === "") return null;
  return key;
}

export function isTurnstileEnabled(): boolean {
  return getTurnstileSiteKey() !== null;
}

export const CAPTCHA_ERROR_MESSAGE =
  "Falha na verificação de segurança. Recarregue a página e tente novamente.";

/**
 * Copy pra quando o widget fica indisponível (script não carregou, browser
 * não suportado, ou timeout sem widget). Compartilhada entre login e outros
 * fluxos com captcha (ex: troca de senha) — mesmo tom em todo o app.
 */
export const CAPTCHA_UNAVAILABLE_MESSAGE =
  "Verificação de segurança indisponível. Desative bloqueadores de anúncio e recarregue a página.";

/**
 * Distingue falha de captcha de credencial inválida. Sem isso o usuário com a
 * senha CERTA veria "Email ou senha inválidos" e tentaria em loop.
 */
export function isCaptchaError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const { code, message } = error as { code?: unknown; message?: unknown };
  if (code === "captcha_failed") return true;
  return typeof message === "string" && message.toLowerCase().includes("captcha");
}
